import {
  getTaskModelRelatedEntityPropertyPath,
  TaskModel
} from '../../api/Argentia/endpoints/tasks/model/tasks'
import { EnumDominioTarea } from '../../api/oData/enums/enumDominioTarea'
import { getNestedProperty } from '../../helpers/objectHelper/objectHelper'

export function getTaskModelRelatedEntityValue<T extends TaskModel>(entity: T): any[] | undefined {
  // obtain domain
  const domain = entity?.taskType?.domain
  if (!domain) return undefined

  // obtain entity properties
  const propertyPath = getTaskModelRelatedEntityPropertyPath(domain)
  if (!propertyPath) return undefined

  const value = getNestedProperty(entity, propertyPath)
  return value
}
